import { Component, inject } from '@angular/core';
import { ToastService } from '@vallift/ngl';
import type { DataLibraryListItemResponse } from '@core/api/workspace/models/dataLibraryListItemResponse';

@Component({
  selector: 'app-data-library-key-cell',
  template: `
    <div class="flex items-center gap-2">
      <span
        class="inline-flex max-w-full truncate rounded-md border border-neutral-200 bg-neutral-50 px-2 py-1 font-mono text-xs text-neutral-800">
        {{ rowData?.key }}
      </span>
      <button
        type="button"
        class="inline-flex shrink-0 cursor-pointer items-center justify-center rounded p-1 text-neutral-500 transition hover:bg-neutral-100 hover:text-neutral-800"
        aria-label="Copy key"
        (click)="copyKey($event)">
        <svg
          class="h-4 w-4"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          aria-hidden="true">
          <path
            d="M16 1H4c-1.1 0-2 .9-2 2v14h2V3h12V1Zm3 4H8c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h11c1.1 0 2-.9 2-2V7c0-1.1-.9-2-2-2Zm0 16H8V7h11v14Z"
            fill="currentColor" />
        </svg>
      </button>
    </div>
  `,
})
export class DataLibraryKeyCellComponent {
  private readonly toasterService = inject(ToastService);

  /** Set by NGL DynamicRenderer. */
  rowData!: DataLibraryListItemResponse;

  copyKey(event: MouseEvent): void {
    event.stopPropagation();
    const key = this.rowData?.key;
    if (!key) {
      return;
    }

    void navigator.clipboard.writeText(key).then(
      () =>
        this.toasterService.success('You can paste it wherever you need it.', {
          title: 'Key copied',
        }),
      () =>
        this.toasterService.error('Please try again.', {
          title: 'Could not copy key',
        }),
    );
  }
}
